import { useContext } from 'react';

import { useLocation, useNavigate, useSearchParams } from '../../wrappers/ReactRouterDom';

import { SecurityStateContext, CurrentNavStateContext, ContextSecurityStateContext } from './SecurityContextProvider';
import SecurityData from './SecurityData';
import { getStoredTokenObj, resetStoredToken, setStoredToken } from '../../utils/TokenUtils';
import { clearUserInfoCache } from '../../utils/UserInfoCache';

const TAXONOMIES = ['TopMenu', 'Footer', 'MainMenu'];
const SCOPE = 'Project';

const useSecurityData = () => {
  const [securityState, setSecurityState] = useContext(SecurityStateContext);
  const [currentNavItem, setCurrentNavItem] = useContext(CurrentNavStateContext);
  const [contextSecurityState, setContextSecurityState] = useContext(ContextSecurityStateContext);
  const [searchParams,] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const getUserInfo = () => {
    const userInfo = securityState.userInfo || {};
    userInfo.isLoggedIn = userInfo?.firstName !== 'Anonymous';
    userInfo.isUnregistered = userInfo?.firstName === 'Unregistered';
    return userInfo;
  };

  const login = () => {
    resetStoredToken();
    SecurityData.login();
  };

  const logout = (retUrl) => {
    retUrl = retUrl || window.location.origin;
    clearUserInfoCache();
    resetStoredToken();
    SecurityData.logout(retUrl);
  };

  const logoutGoToCreateALogin = (childMemberId) => {
    clearUserInfoCache();
    resetStoredToken();
    SecurityData.logoutWithMemberIdParam(childMemberId);
  };

  const logoutGoToAccountCreation = (paramsObj) => {
    clearUserInfoCache();
    resetStoredToken();
    SecurityData.logoutWithParams(paramsObj);
  };

  const closeSecondaryNav = () => {
    setCurrentNavItem({});
  };

  const onPrimaryNavItemChanged = (newNavItem) => {
    if (!newNavItem && !currentNavItem) return;
    if (newNavItem?.displayName === currentNavItem?.displayName) return;

    setCurrentNavItem({ ...newNavItem });
  };

  const resetContextSecurityState = () => {
    setContextSecurityState({ ...SecurityData.CONTEXT_SECURITY_INITIAL_STATE });
  };

  const getContextSecurity = (contextId, taxonomies, scope) => {
    return SecurityData.getRoutesForContext(contextId, taxonomies, scope, contextSecurityState, setContextSecurityState);
  };

  const verifyUser = () => {
    const storedTokenObj = getStoredTokenObj();

    if (securityState.isObjLoaded === false) {
      SecurityData.GetSecurityInfoForToken(TAXONOMIES, SCOPE, storedTokenObj.token, false, securityState, setSecurityState);
    }
  };

  const bustSecurityCache = () => {
    const storedTokenObj = getStoredTokenObj();

    SecurityData.GetSecurityInfoForToken(TAXONOMIES, SCOPE, storedTokenObj.token, true, securityState, setSecurityState);
  };

  const setContextNavVisibility = (showNav) => {
    setContextSecurityState({
      ...contextSecurityState,
      showNav
    });
  };

  return {
    securityState,
    userInfo: getUserInfo(),
    contextSecurityState,
    setContextNavVisibility,
    currentNavItem,
    closeSecondaryNav,
    login,
    logout,
    logoutGoToCreateALogin,
    logoutGoToAccountCreation,
    onPrimaryNavItemChanged,
    resetContextSecurityState,
    getContextSecurity,
    verifyUser,
    bustSecurityCache
  };
};

export default useSecurityData;